export default "__VITE_ASSET__BxBzkMxr__"